import Styles from './styles.module.css';
import React from 'react';

type ConfirmDialogProps = {
  title: string;
  desc: string;
  confirmLabel: string;
  cancelLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ title, desc, confirmLabel, cancelLabel = 'キャンセル', danger, onConfirm, onCancel }) => {
  return (
    <div className={Styles.overlay} role='dialog' aria-modal='true'>
      <div className={Styles.scrim} onClick={onCancel} />
      <div className={Styles.card}>
        <h3 className={Styles.title}>{title}</h3>
        <p className={Styles.desc}>{desc}</p>
        <div className={Styles.actions}>
          <button type='button' className={Styles.cancel} onClick={onCancel}>{cancelLabel}</button>
          <button type='button' className={danger ? Styles.danger : Styles.confirm} onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;
